import ErrorReporter from "@soenergy/frontend-library/src/services/ErrorReporter"

export default data => {
  const { skipErrorReporting } = data.config
  if (!skipErrorReporting) {
    const errorParams = {}

    const requestData = data.request && data.request.data
    const responseData = data.response && data.response.data
    if (requestData) {
      errorParams["request data"] = requestData
    }
    if (responseData) {
      errorParams["response data"] = responseData
      if (responseData.errors) {
        errorParams["server errors"] = responseData.errors
      }
    }

    ErrorReporter.report(data, errorParams)
  }
  return Promise.reject(data)
}
